import { keyBy } from 'lodash';

import { type DropdownMenuOption } from '@air/primitive-dropdown-menu';

import {
  type AudioVisualFilters,
  baseFiltersOptions,
  type FilterSelectType,
  type FilterType,
} from '~/components/FiltersMenu/types';
import { getFilterProps } from '~/components/FiltersMenu/utils/getFilterProps';
import { type SelectedFilter } from '~/store/filters/types';

export const getAudioVisualFiltersOptions = ({
  selectedFilters,
  audioVisualFilters,
  onSelect,
  disabledFilters,
}: {
  selectedFilters: SelectedFilter[];
  audioVisualFilters: AudioVisualFilters[];
  onSelect: FilterSelectType;
  disabledFilters?: FilterType[];
}) => {
  const selectedFiltersTypes = keyBy(selectedFilters, 'type');

  const options: DropdownMenuOption[] = audioVisualFilters.map((filter) => ({
    ...getFilterProps({
      type: filter,
      onSelect,
      isSelected: !!selectedFiltersTypes[filter],
      disabled: disabledFilters?.includes(filter),
    }),
    label: baseFiltersOptions[filter].label,
    prefix: null,
    type: 'item',
  }));

  return options;
};
